var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress",style:({
      'background-color': _vm.lightColor
    })},[_c('div',{staticClass:"progress-bar",style:({
        'width': `${_vm.value}%`,
        'background-color': _vm.color
      })}),_c('div',{staticClass:"bar-percent d-flex align-items-center"},[_vm._v(" "+_vm._s(_vm.value)+"% ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }